import React from 'react'

interface Props {
	className?: string
}
export const Logo: React.FC<Props> = (props) => {
	return (
		<svg version='1.1' id='Layer_1' x='0px' y='0px' viewBox='0 0 612 667.8' {...props}>
			<g>
				<g>
					<path d='M590.7,577.8H18.1V5.3h572.6V577.8z M44.7,551.3h519.5V31.8H44.7V551.3z' />
				</g>
				<g>
					<path
						d='M237.8,526.1l-18.3-57.4h-11.9v57.4h-23.8V382.2H221c21.8,0,36.2,8.6,36.2,30.4v25.7
				c0,13.8-5.8,22.4-15.6,26.7l20.6,61.1H237.8z M207.6,448.2h12.5c7.8,0,13.2-2.9,13.2-13.2v-18.7c0-10.3-5.3-13.2-13.2-13.2h-12.5
				V448.2z'
					/>
					<path
						d='M341.4,497.3c0,22.2-14.4,30.4-36.2,30.4h-0.4c-21.8,0-36.2-8-36.2-30.4v-86.4c0-21.4,14.4-30.4,36.2-30.4
				h0.4c21.8,0,36.2,9,36.2,30.4v26.3h-23.8v-22.6c0-10.1-4.9-13.2-12.5-13.2c-7.6,0-12.5,3.1-12.5,13.2v79
				c0,10.1,4.9,13.2,12.5,13.2c7.6,0,12.5-3.1,12.5-13.2v-26.1h23.8V497.3z'
					/>
					<path d='M411.7,505.1h-13.4l-21.6-67v88h-22.2V382.2h22.6l27.8,83.7l28-83.7h23.4v143.9h-23v-88L411.7,505.1z' />
					<path
						d='M515.9,433.6v-20.1c0-9-5.1-12.3-12.1-12.3c-7,0-12.1,3.3-12.1,12.3v9.9c0,7.4,2.5,10.7,9.3,14.6l16.9,9.5
				c13.8,7.8,22,14.2,22,29.6v20.8c0,22.2-13.8,30-35.6,30h-0.4c-21.8,0-35.6-7.6-35.6-30v-25.1h23.4v21.8c0,8.8,5.1,12.7,12.3,12.7
				c7.2,0,12.3-3.9,12.3-12.7v-11.3c0-7.4-2.3-11.1-9.5-15l-16.7-9.5c-14-8-22-14.6-22-29.6v-18.9c0-21.4,15.6-29.6,35.4-29.6h0.4
				c19.7,0,35.4,8.2,35.4,29.6v23.4H515.9z'
					/>
				</g>
				<path d='M210,471.1' />
				<g>
					<path
						d='M249.9,641.6c0.4,3,1.2,5.2,2.5,6.6c2.2,2.7,6.1,4,11.5,4c3.2,0,5.9-0.4,7.9-1.1c3.8-1.3,5.8-3.8,5.8-7.5
				c0-2.1-0.9-3.8-2.8-5c-1.9-1.1-4.9-2.1-9-3l-7-1.5c-6.9-1.5-11.6-3.2-14.2-4.9c-4.3-3-6.5-7.6-6.5-14c0-5.8,2.1-10.6,6.4-14.4
				c4.3-3.8,10.5-5.7,18.8-5.7c6.9,0,12.8,1.8,17.6,5.4c4.9,3.6,7.4,8.8,7.6,15.7h-13c-0.2-3.9-2-6.6-5.2-8.3c-2.2-1.1-4.8-1.6-8-1.6
				c-3.6,0-6.4,0.7-8.5,2.1c-2.1,1.4-3.2,3.4-3.2,5.9c0,2.3,1.1,4,3.1,5.2c1.3,0.8,4.2,1.6,8.6,2.7l11.3,2.7c5,1.2,8.7,2.7,11.2,4.7
				c3.8,3,5.8,7.4,5.8,13.2c0,5.9-2.3,10.8-6.8,14.7c-4.6,3.9-11,5.8-19.3,5.8c-8.5,0-15.2-1.9-20.1-5.8c-4.9-3.8-7.3-9.1-7.3-15.8
				H249.9z'
					/>
					<path
						d='M337.3,655.7c-4,5-10.1,7.5-18.4,7.5c-8.2,0-14.3-2.5-18.3-7.5c-4-5-6-11-6-18c0-6.9,2-12.8,6-17.9
				c4-5,10.1-7.6,18.3-7.6c8.2,0,14.3,2.5,18.4,7.6c4,5,6,11,6,17.9C343.4,644.7,341.3,650.7,337.3,655.7z M327.3,648.8
				c2-2.6,2.9-6.3,2.9-11.1c0-4.8-1-8.5-2.9-11c-1.9-2.6-4.8-3.9-8.4-3.9s-6.5,1.3-8.4,3.9c-2,2.6-3,6.3-3,11c0,4.8,1,8.5,3,11.1
				c2,2.6,4.8,3.9,8.4,3.9S325.4,651.4,327.3,648.8z'
					/>
					<path
						d='M368,596.4c0.6,0,1.5,0.1,2.6,0.2v10.2c-0.7-0.1-1.9-0.2-3.5-0.2c-1.6,0-2.8,0.3-3.4,1.1s-0.9,1.6-0.9,2.6
				c0,0.9,0,2.3,0,4h8.2v8.8h-8.2v38.5h-12.4V623h-7v-8.8h6.8v-3.1c0-5.1,0.9-8.6,2.6-10.6c1.8-2.9,6.2-4.3,13.1-4.3
				C366.6,596.3,367.4,596.3,368,596.4z'
					/>
					<path
						d='M372.2,623.1v-8.9h6.7v-13.3h12.3v13.3h7.7v8.9h-7.7v25.2c0,2,0.2,3.2,0.7,3.7c0.5,0.5,2,0.7,4.6,0.7
				c0.4,0,0.8,0,1.2,0c0.4,0,0.8,0,1.2-0.1v9.3l-5.9,0.2c-5.9,0.2-9.9-0.8-12.1-3.1c-1.4-1.4-2.1-3.6-2.1-6.6v-29.4H372.2z'
					/>
					<path
						d='M429.5,613.8h12.7l7.3,34.4l7.5-34.4h13L456,661.5h-12.8l-7.5-34.8l-7.6,34.8h-13l-13.4-47.7h13.4l7.5,34.2
				L429.5,613.8z'
					/>
					<path
						d='M492,632.5c2.3-0.3,4-0.7,5-1.1c1.8-0.8,2.7-1.9,2.7-3.5c0-2-0.7-3.3-2.1-4c-1.4-0.7-3.4-1.1-6.1-1.1
				c-3,0-5.1,0.7-6.4,2.2c-0.9,1.1-1.5,2.5-1.8,4.4h-12c0.3-4.2,1.4-7.6,3.5-10.3c3.3-4.2,9-6.3,17.1-6.3c5.2,0,9.9,1,14,3.1
				c4.1,2.1,6.1,6,6.1,11.7v21.9c0,1.5,0,3.4,0.1,5.5c0.1,1.6,0.3,2.7,0.7,3.3c0.4,0.6,1,1.1,1.8,1.4v1.8h-13.6
				c-0.4-1-0.6-1.9-0.8-2.7c-0.1-0.8-0.3-1.8-0.3-2.9c-1.7,1.9-3.7,3.5-6,4.8c-2.7,1.5-5.7,2.3-9.2,2.3c-4.3,0-7.9-1.2-10.8-3.7
				c-2.8-2.5-4.3-6-4.3-10.5c0-5.9,2.3-10.1,6.8-12.7c2.5-1.4,6.2-2.5,11-3.1L492,632.5z M499.6,638.3c-0.8,0.5-1.6,0.9-2.4,1.2
				c-0.8,0.3-1.9,0.6-3.3,0.9l-2.8,0.5c-2.7,0.5-4.6,1-5.7,1.7c-2,1.1-3,2.9-3,5.3c0,2.1,0.6,3.7,1.8,4.6c1.2,0.9,2.7,1.4,4.4,1.4
				c2.7,0,5.2-0.8,7.5-2.4c2.3-1.6,3.5-4.5,3.6-8.6V638.3z'
					/>
					<path
						d='M545.1,612.7c0.2,0,0.5,0,1.1,0.1v12.8c-0.8-0.1-1.5-0.1-2.1-0.2c-0.6,0-1.1,0-1.5,0c-5,0-8.4,1.6-10.1,4.9
				c-1,1.8-1.4,4.7-1.4,8.5v22.8h-12.6v-47.7h11.9v8.3c1.9-3.2,3.6-5.4,5-6.5c2.3-2,5.4-2.9,9.1-2.9
				C544.8,612.6,545,612.6,545.1,612.7z'
					/>
					<path
						d='M581.1,614.7c3.3,1.5,6.1,3.8,8.2,7.1c2,2.8,3.2,6.1,3.8,9.9c0.3,2.2,0.5,5.3,0.4,9.5h-34.8
				c0.2,4.8,1.9,8.1,5,10.1c1.9,1.2,4.2,1.8,6.9,1.8c2.8,0,5.2-0.7,6.9-2.2c1-0.8,1.8-1.9,2.6-3.3h12.7c-0.3,2.8-1.9,5.7-4.6,8.6
				c-4.3,4.6-10.3,7-17.9,7c-6.4,0-12-2-16.8-5.9c-4.8-3.9-7.3-10.3-7.3-19.1c0-8.3,2.2-14.6,6.6-19s10.1-6.6,17.1-6.6
				C574,612.5,577.8,613.2,581.1,614.7z M562.4,625.5c-1.8,1.8-2.9,4.3-3.3,7.4h21.5c-0.2-3.3-1.3-5.8-3.3-7.5
				c-2-1.7-4.5-2.6-7.4-2.6C566.7,622.8,564.2,623.7,562.4,625.5z'
					/>
				</g>
			</g>
		</svg>
	)
}
